module.exports = __webpack_public_path__ + "assets/img/img262.4bef11f7.png";